import { ValuesByDimension } from '../lineGraph.types';

const minimumEntriesPerDimension = 2;

export const getDimensionKeys = (valuesByDimension: ValuesByDimension) => {
	const allDimensionKeys = Object.keys(valuesByDimension);

	const dimensionKeys = allDimensionKeys.filter((dimensionKey) => {
		const dimensionValues = valuesByDimension[dimensionKey];

		const dimensionCount = Object.keys(dimensionValues).length;

		return dimensionCount >= minimumEntriesPerDimension;
	});

	return dimensionKeys;
};
